import LocalizationStrings from "react-localization";
import { br } from "./BR";

export const strings = new LocalizationStrings({
	br,
});
